<template>
  <div class="common-layout">
    <el-container>
      <el-header>
        <el-menu
          :default-active="$route.path"
          mode="horizontal"
          class="nav"
          router
        >
          <el-image class="logo" :src="logo" fit="cover"></el-image>
          <el-menu-item index="/">HOME</el-menu-item>
          <el-menu-item index="/goods">PRODUCTS</el-menu-item>
          <el-menu-item index="/about">ABOUT US</el-menu-item>
          <el-menu-item index="/contact">CONTACT US</el-menu-item>
        </el-menu>
      </el-header>
      <el-main
        class="main"
        style="padding: 0; min-width: 500px; position: relative"
      >
        <router-view />
      </el-main>
      <el-footer>
        <div class="foot">
          <el-image class="logo" :src="logo" fit="cover"></el-image>
          <p class="email">
            <i class="el-icon-message"></i>
            <span>{{email}}</span>
          </p>
        </div>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import { adminConfigInfo } from "@/request/api";
export default {
  name: "HelloWorld",
  data() {
    return {
      logo: "",
      email: ''
    };
  },
  created() {
    this.getInfo();
  },
  methods: {
    getInfo() {
      adminConfigInfo().then((res) => {
        console.log(res);
        // this.contact_title = res.results[0].contact_title;
        // this.about_body = res.results[0].about_body;
        // this.logo_image = res.results[0].logo;
        this.logo = res.results[0].logo;
        this.email = res.results[0].contact_title;
        // this.about_image = res.results[0].about_page;
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.logo {
  width: 60px;
  height: 60px;
  margin: 0 60px 0 0;
}
.el-menu {
  background-color: white;
  /* text-align: center; */
  color: black;
  display: flex;
  justify-content: center;
}
.user {
  background-color: white;
  color: black;
  font-size: 22px;
  padding: 20px 0;
}
::v-deep .el-submenu__title {
  /* background-color: pink !important; */
}
.el-submenu {
  background-color: rgb(221, 221, 221);
  background-color: #e6e6e6;
}
.el-menu-item {
  /* background-color: pink !important;  */
}
.el-header {
  /* background-color: #409EFF; */
}
.el-menu--horizontal > .el-menu-item.is-active {
  border-bottom: 2px solid #000000;
  color: black;
}
.el-menu--horizontal > .el-menu-item {
  color: black;
}
.el-menu--horizontal > .el-menu-item:not(.is-disabled):focus,
.el-menu--horizontal > .el-menu-item:not(.is-disabled):hover,
.el-menu--horizontal > .el-submenu .el-submenu__title:hover {
  /* background-color: black; */
}
.el-menu-item:not(.is-disabled):focus {
  background-color: transparent;
}
.foot {
  height: 160px;
  color: #9d9d9d;
  background: #fbfbfb;
  border-top: 1px solid #e3e9ed;
  display: flex;
  align-items: center;
  justify-content: center;
}
i {
  font-size: 30px;
  margin-right: 10px;
}
.email {
  display: flex;
  align-items: center;
  justify-content: center;
}
.main {
  min-height: calc(100vh - 220px);
}
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue